export default {
	/**
	 * Add as a vue plugin, enables this object to be passed in Vue.use()
	 * @param  {Object} Vue
	 */
	install(Vue) {
		// eslint-disable-next-line no-param-reassign
		Vue.prototype.$ErrorHandler = {
			reportError: this.reportError,
			parseResponseError: this.parseResponseError,
		};
	},

	/**
	 * Report an error
	 * @param  {String} message - The message to report
	 * @param  {Object} error   - An object with debugging information
	 */
	reportError(message, error) {
		window.console.error(message, error);
	},

	/**
	 * Parse a response error
	 * @param  {Error}  error          - The error instance to parse
	 * @param  {String} defaultMessage - The default error message
	 * @return {Array}                 - A list of error messages
	 */
	parseResponseError(error, defaultMessage) {
		// If there is no response data
		if (!error.response) {
			return [defaultMessage];
		}

		// If there is no error body returned (if 419/500, etc)
		if (!error.response.data.errors) {
			this.reportError('Invalid server response!', error);
			return [defaultMessage];
		}

		const errorMessagesGrouped = Object.values(error.response.data.errors);
		const errorMessages = [].concat(...errorMessagesGrouped);

		// If there are no errors returned
		if (errorMessages.length <= 0) {
			return [defaultMessage];
		}

		return errorMessages;
	},
};
